export default function ReelsSection() {
  const hookExamples = [
    {
      hook: "Stop making these mistakes when buying your first home...",
      type: "Problem-focused opener",
      icon: "ri-alert-line"
    },
    {
      hook: "Everyone keeps asking me this question...",
      type: "Curiosity-driven opener",
      icon: "ri-question-line"
    },
    {
      hook: "You won't believe what you can get for this price...",
      type: "Value-reveal opener",
      icon: "ri-money-dollar-circle-line"
    }
  ];

  return (
    <section className="py-20 px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        {/* Label */}
        <div className="text-center mb-4">
          <span className="text-[#E8603C] text-sm font-semibold tracking-wider uppercase">
            Bonus Content
          </span>
        </div>

        {/* Title */}
        <div className="text-center mb-6">
          <h2 className="font-serif text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Bonus: 30 Reel Hook Scripts Included
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Short-form video is where agents go viral. Every hook is written to stop the scroll and drive profile visits.
          </p>
        </div>

        {/* Hook Examples Cards */}
        <div className="grid md:grid-cols-3 gap-8 mt-16">
          {hookExamples.map((example, index) => (
            <div
              key={index}
              className="bg-[#F6F2EE] rounded-2xl p-8 border border-black/6 hover:shadow-[0_12px_24px_rgba(0,0,0,0.10),0_30px_60px_rgba(0,0,0,0.14)] transition-all duration-200 hover:-translate-y-1"
              style={{
                boxShadow: '0 6px 12px rgba(0,0,0,0.06), 0 18px 40px rgba(0,0,0,0.10)'
              }}
            >
              <div className="w-12 h-12 rounded-full bg-[#E8603C] flex items-center justify-center mb-6">
                <i className={`${example.icon} text-white text-xl`}></i>
              </div>
              <p className="text-lg font-semibold text-gray-900 mb-3 leading-snug">
                "{example.hook}"
              </p>
              <p className="text-sm text-gray-600 font-medium">
                Hook Type: {example.type}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}